import { styled } from '@linaria/react';
import { useSpring, animated } from 'react-spring';

import useSequence from './use-sequence.hook';
import Label from './Label';
import {
  BaseWrapper,
  Layer,
  Skew,
  BaseElement,
  BaseMargin,
  ChildElement,
  SPRING_CONFIGS,
} from './bits';

function Multi() {
  const [stepIndex, step, handlers] = useSequence({
    mode: 'interactive',
  });

  const firstSpring = useSpring({
    transform: `translateX(${stepIndex === 0 ? 0 : -60}%)`,
    config: SPRING_CONFIGS[0],
  });

  const secondSpring = useSpring({
    transform: `translateX(${stepIndex === 0 ? 0 : -20}%)`,
    config: SPRING_CONFIGS[0],
  });
  const thirdSpring = useSpring({
    transform: `translateX(${stepIndex === 0 ? 0 : 20}%)`,
    config: SPRING_CONFIGS[0],
  });
  const fourthSpring = useSpring({
    transform: `translateX(${stepIndex === 0 ? 0 : 60}%)`,
    config: SPRING_CONFIGS[0],
  });

  return (
    <Wrapper {...handlers}>
      <Layer style={{ zIndex: 4, ...firstSpring }}>
        <Skew>
          <ChildElement />
          <Margin style={{ height: 20 }} />
        </Skew>
      </Layer>

      <Layer style={{ zIndex: 3, ...secondSpring }}>
        <Skew>
          <BaseElement />
          <Margin style={{ height: 40 }} />
        </Skew>
      </Layer>

      <Layer
        style={{
          top: 20 + 175,
          zIndex: 2,
          ...thirdSpring,
        }}
      >
        <Skew>
          <Margin style={{ height: 60 }} />
          <ChildElement />
        </Skew>
      </Layer>
      <Layer style={{ top: 175, zIndex: 1, ...fourthSpring }}>
        <Skew>
          <Margin style={{ height: 80 }} />
          <BaseElement />
        </Skew>
      </Layer>
    </Wrapper>
  );
}

const Wrapper = styled(BaseWrapper)`
  margin-top: 80px;
  height: 470px;
`;

const Margin = styled(BaseMargin)`
  background: rgba(255, 177, 86, 0.5);
`;

export default Multi;
